<template>
	<div class="tw-flex tw-gap-6 section-content-grid">
		<div class="section-content-grid-left-content">
			<slot name="left" />
		</div>
		<div class="section-content-grid-right-content">
			<slot name="right" />
		</div>
	</div>
</template>

<script>
export default {
	name: 'PSectionContentGrid',
};
</script>

<style lang="scss" scoped>
.section-content-grid {
	&-left-content {
		width: 60%;
	}
	&-right-content {
		width: 40%;
	}
}
</style>



// WEBPACK FOOTER //
// src/modules/shared/components/ui/p-section-content-grid.vue